import Artboard1 from "./Artboard1/Artboard1";
import Artboard2 from "./Artboard2/Artboard2";
import Artboard3 from "./Artboard3/Artboard3";

const Artboards = {
    Artboard1,
    Artboard2,
    Artboard3,
};
export default Artboards;